export const contactUs='contact@sadatcityjobs.com';